import { greekIt } from 'app/util/utils';

/**
 * Format alert count values for display
 * - Shows raw count for values < 1000
 * - Shows lowercase 'k' formatted values for 1000+ (e.g., '1.4k', '434.7k')
 * @param {number} value - The count to format
 * @returns {number|string} Formatted count or raw number
 */
export function formatAlertCount(value) {
  if (value < 1000) {
    return value;
  }
  const formatted = greekIt(value, { fix: 1, forcePrefix: 'K' }).displayFull;
  // Use lowercase 'k' for kilo (not bytes), remove space
  return formatted.replace(' K', 'k');
}
